import { memo, useMemo, useRef } from 'react';
import { Edge, Node } from '@xyflow/react';
import { DEFAULT_SCHEMA_HEIGHT } from '../utils/consts';
import { getNodeTypeVariants, unconnectedEdgeTypes } from '../utils/flowConfig';
import { buildUnconnectedSchema } from '../utils/unconnectedLegs';
import { TreeLeg } from '../utils/treeLayout';
import { ReadonlyFlowCanvas } from './ReadonlyFlowCanvas';

type UnconnectedLegsSchemaProps = {
  legs: TreeLeg[];
  schemaType?: 'main' | 'alt';
};

export const UnconnectedLegsSchema = memo(({ legs, schemaType = 'main' }: UnconnectedLegsSchemaProps) => {
  const nodeTypeVariants = useRef(getNodeTypeVariants(schemaType));

  const { nodes, edges, totalWidth } = useMemo(() => buildUnconnectedSchema(legs), [legs]);

  const defaultEdgeOptions = useMemo(() => ({ label: schemaType }), [schemaType]);

  if (!legs.length) return null;

  return (
    <div className="rounded-lg bg-base-80 p-3 flex flex-col gap-2">
      <div className="flex items-center gap-1.5">
        <span className="text-s-sb text-base-5">Unconnected Legs</span>
        <span className="flex items-center justify-center w-5 h-5 rounded-full bg-base-5 text-white text-xs-m leading-none">
          {legs.length}
        </span>
      </div>

      <ReadonlyFlowCanvas
        nodes={nodes as Node[]}
        edges={edges as Edge[]}
        nodeTypes={nodeTypeVariants.current}
        edgeTypes={unconnectedEdgeTypes}
        defaultEdgeOptions={defaultEdgeOptions}
        width={totalWidth}
        height={DEFAULT_SCHEMA_HEIGHT}
      />
    </div>
  );
});
